export enum SnackbarState {
  NONE = 'none',
  ERROR = 'error',
  COPIED = 'copied',
  DELETED = 'deleted',
  CREATED = 'created',
}

export enum TokenEnvironments {
  PRODUCTION = 'production',
  SANDBOX = 'sandbox',
}
